import {useMutation} from '@tanstack/react-query';
import {postInvoicePdf} from '../../services/postInvoicePdf';

const usePostInvoicePdfMutation = () =>
	useMutation({
		mutationFn: postInvoicePdf,
	});

export {usePostInvoicePdfMutation};
